import { render, staticRenderFns } from "./planos.vue?vue&type=template&id=09c77988&scoped=true&"
import script from "./planos.vue?vue&type=script&lang=js&"
export * from "./planos.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/bootstrap.min.css?vue&type=style&index=0&id=09c77988&scoped=true&lang=css&"
import style1 from "./planos.vue?vue&type=style&index=1&id=09c77988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c77988",
  null
  
)

export default component.exports